import { Box, Grid, Stack, Text, Title, Flex } from '@mantine/core'
import React from 'react'
import { getText } from '../../utils/constants'
import Image from 'next/image'
import { Divider } from '@mantine/core'
import Link from 'next/link'

const CountryDetail = ({ label, value }) => (
  <Box
    sx={{
      boxShadow: '0px -1px 0px 0px rgba(123,57,182,1) inset',
      padding: '12px 16px',
      backgroundColor: '#0E1922',
      borderRadius: '8px',
      flex: 1,
      height: '100%'
    }}
  >
    <Text weight="bold" size="xs" color="dimmed" style={{ marginBottom: 4 }}>
      {label}
    </Text>
    <Text size="sm" color="white">
      {value}
    </Text>
  </Box>
)

const PlatformOverviewSection = ({ availablePlatforms }) => {
  const t = (key) => getText('Platforms', key)

  return (
    <Box mt={24}>
      <Stack spacing="lg">
        <Stack spacing="xs">
          <Flex direction="column" justify="left" align="flex-start">
            <Title order={2} color="white" tt="uppercase">
              {availablePlatforms?.platform_names?.[0]
                ? t('overviewTitle') + availablePlatforms?.platform_names?.[0]
                : t('unknownPlatform')}
            </Title>
            <Divider
              size="sm"
              sx={{ borderColor: '#7b39b6' }}
              w={40}
              mt={3}
              mb={15}
            />
          </Flex>
          <Flex
            direction="row"
            gap="lg"
            mb={20}
            sx={(theme) => ({
              [theme.fn.smallerThan('sm')]: {
                justifyContent: 'center'
              }
            })}
          >
            {availablePlatforms?.links?.web && (
              <Link href={availablePlatforms.links.web} target="_blank">
                <Image src="/world.png" width={30} height={30} alt="web icon" />
              </Link>
            )}
            {availablePlatforms?.links?.android && (
              <Link href={availablePlatforms.links.android} target="_blank">
                <Image
                  src="/googleplay.png"
                  width={30}
                  height={30}
                  alt="playstore icon"
                />
              </Link>
            )}
            {availablePlatforms?.links?.ios && (
              <Link href={availablePlatforms.links.ios} target="_blank">
                <Image
                  src="/appstore.png"
                  width={30}
                  height={30}
                  alt="appstore icon"
                />
              </Link>
            )}
          </Flex>
        </Stack>

        <Grid gutter="sm">
          <Grid.Col xs={12} sm={6} md={4}>
            <CountryDetail
              label={t('category')}
              value={availablePlatforms?.category || t('miscellaneous')}
            />
          </Grid.Col>
          <Grid.Col xs={12} sm={6} md={4}>
            <CountryDetail
              label={t('businessModels')}
              value={availablePlatforms?.business_model || t('defaultBusinessModel')}
            />
          </Grid.Col>
          <Grid.Col xs={12} sm={6} md={4}>
            <CountryDetail
              label={t('launchYear')}
              value={availablePlatforms?.launch_year || t('defaultLaunchYear')}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Box
              sx={{
                padding: '16px',
                backgroundColor: '#0E1922',
                borderRadius: '8px',
                boxShadow: '0px -1px 0px 0px rgba(123,57,182,1) inset',
                flex: 1
              }}
            >
              <Text
                weight="bold"
                size="xs"
                color="dimmed"
                style={{ marginBottom: 4 }}
              >
                {t('description')}
              </Text>
              <Text size="sm" color="white">
                {availablePlatforms.description}
              </Text>
            </Box>
          </Grid.Col>

          <Grid.Col xs={12} sm={6} md={3}>
            <CountryDetail
              label={t('contentAggregator')}
              value={availablePlatforms?.content_aggregator ? t('yes') : t('no')}
            />
          </Grid.Col>
          <Grid.Col xs={12} sm={6} md={3}>
            <CountryDetail
              label={t('originals')}
              value={availablePlatforms?.originals ? t('yes') : t('no')}
            />
          </Grid.Col>
          <Grid.Col xs={12} sm={6} md={3}>
            <CountryDetail
              label={t('liveChannelsOrEvents')}
              value={availablePlatforms?.live_chanels_or_events ? t('yes') : t('no')}
            />
          </Grid.Col>
          <Grid.Col xs={12} sm={6} md={3}>
            <CountryDetail
              label={t('ads')}
              value={availablePlatforms?.ads ? t('yes') : t('no')}
            />
          </Grid.Col>
        </Grid>
      </Stack>
    </Box>
  )
}

export default PlatformOverviewSection
